import { useCallback, useState } from "react";
import { UseDeleteProps } from "./types";
import { DELETE_QUERY, DeleteGql } from "../queries/delete";
import { ApiCourseRequest } from "data/queries/ApiCourse";

const useDelete = ({ queryParam, setSnackBarInfo, setEditing }: UseDeleteProps) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteError = (e: any) => {
    const stackError =
      e?.response?.data?.errors?.[0]?.extensions?.error?.stack ||
      e?.extensions?.error?.stack ||
      e?.message ||
      "";
    if (stackError?.includes("Foreign key constraint violated")) {
      return setSnackBarInfo({
        open: true,
        color: "error",
        title: "Ops, Não pode excluir esse grupo de cursos",
        content:
          "Esse grupo de cursos possuí cursos cadastrados e não pode ser excluída. Edite os cursos que possuem esse grupo de cursos antes de excluí-lo",
        autoHideDuration: null,
      });
    }
    setSnackBarInfo({
      open: true,
      color: "error",
      title: "Ops, algo deu errado",
      content: e?.message || "Ops. Algo Deu errado",
      autoHideDuration: null,
    });
  };

  const handleDeleteSuccess = () => {
    setEditing(false);
    setSnackBarInfo({
      open: true,
      color: "success",
      icon: "check",
      autoHideDuration: null,
      title: "Deletado com sucesso",
      redirectid: -1,
    });
  };

  const handleDelete = useCallback(async () => {
    setLoading(true);
    try {
      const response = await ApiCourseRequest<DeleteGql>({
        query: DELETE_QUERY,
        variables: { id: queryParam },
      });

      if (!response?.data?.data?.deleteCourseGroup?.id) {
        if (response.data?.errors?.[0]) throw response.data?.errors?.[0];
        throw new Error(JSON.stringify(response?.data || "Algo deu errado!"));
      }

      handleDeleteSuccess();
    } catch (error: any) {
      console.error(error);
      setLoading(false);
      handleDeleteError(error);
    }
  }, [queryParam]);

  return {
    handleDelete,
    handleDeleteSuccess,
    handleDeleteError,
  };
};

export default useDelete;
